export default {"src":"/_next/static/media/Taiwan.047b4f09.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};